export default "__VITE_ASSET__B3FPHx5i__"